import { combineReducers } from '@reduxjs/toolkit';
import form from './formSlice';

const fuseReducers = combineReducers({
	form
});

export default fuseReducers;
